
(function () {
  'use strict';

  /* Garde-fou : exécuter une seule fois même si le snippet est rendu 2x */
  if (window.__casemiraCardSwipeInit) return;
  window.__casemiraCardSwipeInit = true;

  /* ----------------------------------------------------------------------
     1) Détection tactile : on n'active le swipe QUE si le pointeur n'a pas
        de hover (vrai mobile/tablette). Sur desktop tactile-hybride, on
        laisse le hover natif tranquille.
  ---------------------------------------------------------------------- */
  var isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!isTouch) return; /* desktop : on s'arrête, hover natif intact */

  /* ----------------------------------------------------------------------
     2) CSS injecté une seule fois dans <head>.
        IMPORTANT : on cible le wrapper image. On force l'image --second
        à s'afficher sur mobile (le thème la met en `hidden`), on les
        empile via le track flex, et on dessine les dots.
  ---------------------------------------------------------------------- */
  if (!document.getElementById('casemira-card-swipe-css')) {
    var css = document.createElement('style');
    css.id = 'casemira-card-swipe-css';
    css.textContent = [
      '@media (hover: none) and (pointer: coarse){',
      /* le wrapper devient la fenêtre de visu, masque le débordement */
      '  .product-card__image-wrapper.cms-swipe{position:relative;overflow:hidden;touch-action:pan-y;}',
      /* on neutralise le positionnement absolu de la 2e image et on crée un rail */
      '  .product-card__image-wrapper.cms-swipe .cms-swipe-track{display:flex;width:200%;transition:transform .35s cubic-bezier(.22,.61,.36,1);will-change:transform;}',
      '  .product-card__image-wrapper.cms-swipe .cms-swipe-track.cms-no-anim{transition:none;}',
      /* chaque slide prend la moitié du rail (= 100% du wrapper) */
      '  .product-card__image-wrapper.cms-swipe .product-card__image{position:relative !important;inset:auto !important;flex:0 0 50%;width:50%;max-width:50%;display:block !important;}',
      /* on annule le hidden md:block du thème pour la 2e image sur mobile */
      '  .product-card__image-wrapper.cms-swipe .product-card__image--second{visibility:visible !important;opacity:1 !important;}',
      /* dots */
      '  .product-card__image-wrapper.cms-swipe .cms-dots{position:absolute;left:0;right:0;bottom:8px;display:flex;justify-content:center;gap:6px;z-index:3;pointer-events:none;}',
      '  .product-card__image-wrapper.cms-swipe .cms-dot{width:6px;height:6px;border-radius:50%;background:rgba(15,30,46,.28);box-shadow:0 0 0 1px rgba(255,255,255,.55);transition:background .2s,width .2s;}',
      '  .product-card__image-wrapper.cms-swipe .cms-dot.is-active{background:#0F1E2E;width:14px;border-radius:3px;}',
      '}'
    ].join('');
    document.head.appendChild(css);
  }

  /* ----------------------------------------------------------------------
     3) Câblage d'une carte.
  ---------------------------------------------------------------------- */
  function setupCard(wrapper) {
    if (!wrapper || wrapper.dataset.cmsSwipe === '1') return;

    var motion = wrapper.querySelector('motion-element') || wrapper;
    var imgMain = wrapper.querySelector('.product-card__image--main');
    var imgSecond = wrapper.querySelector('.product-card__image--second');

    /* Fallback : pas de 2e image propre -> on ne fait rien (lifestyle seul) */
    if (!imgMain || !imgSecond) return;

    wrapper.dataset.cmsSwipe = '1';
    wrapper.classList.add('cms-swipe');

    /* On crée le rail et on y déplace les 2 images, sans casser le lien <a> */
    var track = document.createElement('div');
    track.className = 'cms-swipe-track';
    /* insérer le rail là où était la 1re image, puis y pousser les 2 images */
    imgMain.parentNode.insertBefore(track, imgMain);
    track.appendChild(imgMain);
    track.appendChild(imgSecond);

    /* Dots */
    var dots = document.createElement('div');
    dots.className = 'cms-dots';
    dots.innerHTML = '<span class="cms-dot is-active"></span><span class="cms-dot"></span>';
    wrapper.appendChild(dots);
    var dotEls = dots.querySelectorAll('.cms-dot');

    var index = 0;          /* 0 = lifestyle, 1 = vue complète */
    var startX = 0, startY = 0, curX = 0, dragging = false, decided = false, horiz = false;
    var W = function () { return wrapper.clientWidth || 1; };

    function render(animate) {
      track.classList.toggle('cms-no-anim', !animate);
      track.style.transform = 'translateX(' + (-index * 50) + '%)';
      dotEls[0].classList.toggle('is-active', index === 0);
      dotEls[1].classList.toggle('is-active', index === 1);
    }

    function go(to, fireEvent) {
      var clamped = to < 0 ? 0 : (to > 1 ? 1 : to);
      var changed = clamped !== index;
      index = clamped;
      render(true);
      if (changed && fireEvent && index === 1 && !wrapper.dataset.cmsSwiped) {
        wrapper.dataset.cmsSwiped = '1';
        /* event GA4 : 1er swipe vers la vue complète sur cette carte */
        if (window.dataLayer) {
          var titleEl = wrapper.closest('.product-card')
            && wrapper.closest('.product-card').querySelector('.product-card__title');
          window.dataLayer.push({
            event: 'collection_card_swipe',
            product_title: titleEl ? titleEl.textContent.trim() : undefined
          });
        }
      }
    }

    /* --- gestes tactiles --- */
    function onStart(e) {
      var t = e.touches ? e.touches[0] : e;
      startX = curX = t.clientX; startY = t.clientY;
      dragging = true; decided = false; horiz = false;
      track.classList.add('cms-no-anim');
    }
    function onMove(e) {
      if (!dragging) return;
      var t = e.touches ? e.touches[0] : e;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      curX = t.clientX;

      if (!decided) {
        /* on décide tôt : geste horizontal -> swipe, vertical -> scroll page */
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
          decided = true;
          horiz = Math.abs(dx) > Math.abs(dy);
        }
      }
      if (horiz) {
        e.preventDefault(); /* on prend la main sur le geste horizontal */
        var base = -index * W();
        var offset = base + dx;
        /* résistance aux bords */
        if ((index === 0 && dx > 0) || (index === 1 && dx < 0)) offset = base + dx * 0.35;
        track.style.transform = 'translateX(' + (offset / W() * 50) + '%)';
      }
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('cms-no-anim');
      if (!horiz) { render(true); return; }
      var dx = curX - startX;
      var threshold = W() * 0.18;
      if (dx <= -threshold) go(index + 1, true);
      else if (dx >= threshold) go(index - 1, true);
      else render(true);
    }

    /* Empêche le clic sur le lien si on vient de swiper horizontalement */
    var link = wrapper.querySelector('a[href]');
    if (link) {
      link.addEventListener('click', function (e) {
        if (Math.abs(curX - startX) > 10 && horiz) { e.preventDefault(); }
      });
    }

    wrapper.addEventListener('touchstart', onStart, { passive: true });
    wrapper.addEventListener('touchmove', onMove, { passive: false });
    wrapper.addEventListener('touchend', onEnd, { passive: true });
    wrapper.addEventListener('touchcancel', onEnd, { passive: true });

    render(false);
  }

  /* ----------------------------------------------------------------------
     4) Init + re-câblage après filtrage AJAX.
  ---------------------------------------------------------------------- */
  function scan(root) {
    (root || document).querySelectorAll('.product-card__image-wrapper').forEach(setupCard);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    scan(document);

    /* La grille est remplacée lors du filtrage Search&Discovery (facet-form).
       On observe le conteneur produits et on re-scanne les nouvelles cartes. */
    var grid = document.getElementById('ProductGridContainer') || document.body;
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scan(document);
          break;
        }
      }
    });
    mo.observe(grid, { childList: true, subtree: true });
  });
})();
